module.exports = __webpack_public_path__ + "img/verdico.424a5255.svg";